export const ConsentAppActionType = {
    SET_ACTIVE_CONSENT_PAGE_NAME: "SET_ACTIVE_CONSENT_PAGE_NAME",
    SET_ACTIVE_CONSENT_SCREEN_NAME: "SET_ACTIVE_CONSENT_SCREEN_NAME",
    SET_LOGIN_NOTIFICATION_FLAG: "SET_LOGIN_NOTIFICATION_FLAG"
}